import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import TypewriterText from "./TypewriterText";

const FlippingCard = ({ question, answer, icon, isActive, onCardClick }) => {
  const [showTypewriter, setShowTypewriter] = useState(false);

  useEffect(() => {
    if (!isActive) {
      setShowTypewriter(false);
    }
  }, [isActive]);

  const handleCardClick = () => {
    if (!isActive) {
      setShowTypewriter(true);
    }
    onCardClick();
  };

  return (
    <motion.div
      className="w-full h-60 cursor-pointer"
      onClick={handleCardClick}
      initial={{ opacity: 0, y: 30, scale: 0.95 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      style={{ perspective: "1000px" }}
    >
      <div
        className={`relative w-full h-full transition-transform duration-700 transform-style-3d ${
          isActive ? "rotate-y-180" : ""
        }`}
        style={{ transformStyle: "preserve-3d" }}
      >
        {/* Front */}
        <div className="absolute inset-0 backface-hidden bg-white border border-border rounded-xl p-6 flex flex-col items-center justify-center text-center z-10">
          <div className="text-2xl mb-4 leading-none">{icon}</div>
          <h3 className="text-xl font-medium text-foreground">{question}</h3>
        </div>

        {/* Back */}
        <div
          className="absolute inset-0 backface-hidden bg-white border border-border rounded-xl p-6 flex items-center justify-center"
          style={{ transform: "rotateY(180deg)" }}
        >
          <div className="text-base text-muted-foreground leading-relaxed text-center w-full">
            {showTypewriter ? <TypewriterText text={answer} /> : null}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default FlippingCard;
